import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {filterArticle_template} from "./filterArticle_template";
import { infoButton_template }  from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export interface pinnedArticle {

    id:             string;
    idArticle:      string;
    reference:      string;
    article:        object;
    alternateTitle: string;
    badge?:         string;
    pinnedHours:    string;
    position:       string;
    expire:         string;
    timeLeft:       string;
    enableEdit:     boolean;
}

export class pinnedArticles_template extends vnTemplate {

    public articleFilter : filterArticle_template;
    public tooltip : infoButton_template;

    protected getTemplateHtml(): string {

        return /*html*/`
                <div class="w-pinned">
                
                    <div class="pinned-form">
                               
                       ${this.articleFilter.getHtmlBuild()}
                       
                        <div>
                            <label class="form-label icon i-overwrite">Alternate Title</label>
                            <input type="text" class="input-text" data-bind="value: alternateTitle"/>
                        </div>
                        <div data-bind="visible: isBadgeEnabled()">
                            <label class="form-label icon i-text">Badge</label>
                            <input type="text" class="input-text" data-bind="value: badge"/>
                        </div>
                        <div class="no-margin">
                            <label class="form-label icon i-hourglass">Hours Pinned</label>
                            <input data-bind="value: pinnedHours" onKeyPress="if(this.value.length==3) return false;" class="input-text number"  type="number" id="" name="" min="0">
                            <div class="w-tooltips-adv pos-top short" data-bind="visible : isToolTipVisible()">
                                ${this.tooltip.getHtmlBuild()}
                            </div>
                        </div>
                        <div class="right ">
                            <button class="btn secondary" type="button" data-bind="enable: articles().length < maximum(), event:{click: onClickAdd }, text: 'Add to Position ' + (articles().length + 1)"></button>
                        </div>
                      
                    </div>

                    <div class="form-body" data-bind="foreach: articles, childrenComplete : handleDragAndDrop($element, articles ,'.entry')">
                            
                       <div class="pinned-form article-pinned entry" data-bind="css: {'is-edit' : enableEdit}">
                       
                             <div class="pinned-drag icon i-drag">
                                <span class="pinned-position" data-bind="text: ($index() + 1)"></span>                                   
                             </div>
                             
                             <div class="w-btn" data-bind="visible: !enableEdit">
                                <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEdit }"><span class="hidden-text">Edit</span></button>
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDelete }"><span class="hidden-text">Delete</span></button>
                             </div>
                            
                             <div class="w-title">
                                <div>
                                    <span class="pinned-info">ID :<span data-bind="text: article.id"></span></span>
                                    <span class="pinned-info">Last Published :<span data-bind="text: article.dateLastPublishStatus"></span></span>
                                </div>
                                <span class="pinned-title" data-bind="text: article.title"></span>
                             </div>
                             
                             <div class="last">
                                <label class="form-label icon i-overwrite"></label>
                                <span class="pinned-title" data-bind=" visible: !enableEdit, text: alternateTitle"></span>
                                <input type="text" class="input-text"  type="text" data-bind="visible: enableEdit, value: alternateTitle, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                             </div>
                             <!-- ko if: $parent.isBadgeEnabled() -->
                             <div class="last">
                                <label class="form-label icon i-text"></label>
                                <span class="pinned-title" data-bind=" visible: !enableEdit, text: badge"></span>
                                <input type="text" class="input-text" data-bind="visible: enableEdit, value: badge, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                             </div>
                             <!-- /ko -->
                            
                             <div class="w-time">
                                <div data-bind="visible: !enableEdit">
                                    <label class="form-label icon i-hourglass" data-bind="visible: timeLeft != ''"></label>
                                    <span class="pinned-time" data-bind="text: timeLeft"></span>
                                </div>
                                <div data-bind="visible: enableEdit">
                                    <label class="form-label icon i-hourglass"></label>
                                    <input class="input-text number" type="number" min="0" data-bind="value: pinnedHours, event:{ focus: $parent.onFocus, blur: $parent.onBlur}" onKeyPress="if(this.value.length==3) return false;"/>
                                </div>
                             </div>
                             
                       </div>
                   
                    </div>
                        
                </div>
                
                <div data-bind="visible: articles().length == 0">
                     <p class="form-text">There is nothing currently pinned.</p>
                </div>
               
                `;
    }

    protected getTemplateName(): string {
        return `${this.idElement}_pinnedArticles-template`;
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected initPartial() {

        this.articleFilter =  new filterArticle_template(`${this.idElement}_articleFilter`, this.getTemplateViewModel(), this.caller);
        // this.articleFilter =  new filterArticle_template('articleFilter', this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);

        this.tooltip = new infoButton_template('tooltip', this.getTemplateViewModel(), this.caller);
        this.tooltip.setTitle('Hours Pinned');
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
             maximum: ko.observable(25)
            ,isToolTipVisible: ko.observable(false)
            ,isBadgeEnabled: ko.observable(false)
            ,articles: ko.observableArray([])
            ,alternateTitle: ko.observable('')
            ,badge: ko.observable('')
            ,pinnedHours: ko.observable('')
            ,onClickAdd: function (data, event) {
                huit_neuf_this.onClickAdd();
            }
            ,onClickEdit: function (data, event) {
                huit_neuf_this.onClickEdit(data);
            }
            ,onClickDelete: function (data, event) {
                huit_neuf_this.onClickDelete(data);
            }
            ,handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){
                huit_neuf_this.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
            }
            ,onFocus: function(data, event){
                huit_neuf_this.onFocus(data, event);
            }
            ,onBlur: function(data, event){
                huit_neuf_this.onBlur(data, event);
            }
        };
    }

    public setMaximum(maximum){

        this.getTemplateViewModel().maximum(maximum)
    }

    public setIsToolTipVisible(bool){

        this.getTemplateViewModel().isToolTipVisible(bool)
    }

    public setIsBadgeEnabled(bool){

        this.getTemplateViewModel().isBadgeEnabled(bool)
        if (bool) {
            this.getTemplateViewModel().articles(this.normalizeBadgeForArticles(this.getTemplateViewModel().articles()));
        }
    }

    public setArticles(articles: Array<any>): void {

        if (this.getTemplateViewModel().isBadgeEnabled()) {
            articles = this.normalizeBadgeForArticles(articles);
        }
        this.getTemplateViewModel().articles(articles);
    }

    private normalizeBadgeForArticles(articles: Array<any>): Array<any> {

        return articles.map((article) => {
            if (article && typeof article.badge === 'undefined') {
                article.badge = '';
            }

            return article;
        });
    }

    public getArticlesCount(){
        return this.getTemplateViewModel().articles().length;
    }

    public getArticlesMarkedAsUnedited(){
        return this.changeArticlesEditionStatus(false);
    }

    public getArticlesMarkedAsEdited(){
        return this.changeArticlesEditionStatus(true);
    }

    private changeArticlesEditionStatus(edited: boolean){

        return this.getTemplateViewModel().articles().map((article) => {
            article.enableEdit = edited;
            return article;
        });
    }

    public getArticles(){

        //update positions first
        this.updatePositions();
        return this.getTemplateViewModel().articles();
    }

    public updatePositions(){

        let articles =  this.getTemplateViewModel().articles();
        for (let i = 0; i < articles.length; i++) {

            articles[i].position = i + 1;
        }

        this.getTemplateViewModel().articles([])
        this.getTemplateViewModel().articles(articles)
    }

    public onClickAdd(){

        if(!this.articleFilter.getTemplateViewModel().idArticle()) {
            this.caller.triggerNotification('Article is mandatory!');
            return;
        }

        let pinnedHours = this.getTemplateViewModel().pinnedHours();
        if( pinnedHours !== '' && (pinnedHours < 1 || pinnedHours % 1 !== 0)) {
            this.caller.triggerNotification('Pinned hours should be a valid positive number!');
            return;
        }

        if(this.getTemplateViewModel().articles().length === this.getTemplateViewModel().maximum()) {
            this.caller.triggerNotification('Maximum number reached. Please delete one to add new! ');
            return;
        }

        let article : pinnedArticle =  {
            'id': '',
            'idArticle': this.articleFilter.getTemplateViewModel().idArticle(),
            'reference': this.articleFilter.getTemplateViewModel().articleObj().reference,
            'article': this.articleFilter.getTemplateViewModel().articleObj(),
            'alternateTitle': this.getTemplateViewModel().alternateTitle(),
            'badge': this.getTemplateViewModel().isBadgeEnabled() ? this.getTemplateViewModel().badge() : '',
            'pinnedHours': this.getTemplateViewModel().pinnedHours(),
            'position': this.getTemplateViewModel().articles().length + 1,
            'timeLeft': (pinnedHours) ? pinnedHours + ':00:00' : '',
            'expire': '',
            'enableEdit': false
        };

        let articles = this.getTemplateViewModel().articles();
        let index = this.getArticleIndex(article);
        if(index > -1){

            this.caller.triggerNotification('Article already pinned!!');

        }else {

            articles.push(article);
            this.getTemplateViewModel().articles([]);
            this.getTemplateViewModel().articles(articles);
            this.clearInput();
        }
    }

    public onClickEdit(data){

        let articles = this.getTemplateViewModel().articles();
        let index = this.getArticleIndex(data);
        if(index > -1){

            let timeLeft = articles[index].timeLeft;
            if(timeLeft != ''){

                let array = timeLeft.split(':');
                let hour = array[0];
                if(array[1] > 30){
                    hour++;
                }

                articles[index].pinnedHours = hour;
                articles[index].timeLeft = '';
                articles[index].expire = '';
            }
            articles[index].enableEdit = true;
        }
        this.getTemplateViewModel().articles([])
        this.getTemplateViewModel().articles(articles);
    }

    public onClickDelete(data){

        let articles = this.getTemplateViewModel().articles();
        let index = this.getArticleIndex(data);
        if(index > -1){
            articles.splice(index, 1)
        }
        this.getTemplateViewModel().articles([])
        this.getTemplateViewModel().articles(articles);
    }

    public getArticleIndex(data){

        let articles = this.getTemplateViewModel().articles();
        let index = articles.findIndex(article => article.idArticle == data.idArticle);
        return index;
    }

    public clearInput(){

        this.articleFilter.getTemplateViewModel().idArticle(null);
        this.articleFilter.getTemplateViewModel().article("");
        this.articleFilter.getTemplateViewModel().articleObj("");
        this.getTemplateViewModel().alternateTitle('');
        this.getTemplateViewModel().badge('');
        this.getTemplateViewModel().pinnedHours('');
    }

    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }

    public onFocus(data, event){

        let parent = event.currentTarget.parentNode.parentNode;
        if(parent.hasAttribute('draggable')){
            parent.setAttribute('draggable', 'false')
        }
    }

    public onBlur(data, event){

        let parent = event.currentTarget.parentNode.parentNode;
        if(parent.hasAttribute('draggable')){
            parent.setAttribute('draggable', 'true')
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/pinnedArticles_template.ts